import Joi from 'joi';
import type { IConfigureParams } from './configureParams';
import { configureParamsSchemaMap } from './configureParams';
import { actionCreator, objectSchemaOf } from '../helpers';

export const CONFIGURE = 'VOICE_TO_TEXT/CONFIGURE';

export interface IConfigurePayload extends IConfigureParams {
  conversationId: string;
}

export const configurePayloadSchema = objectSchemaOf<IConfigurePayload>({
  ...configureParamsSchemaMap,
  conversationId: Joi.string().required(),
});

export const configureActionSchema = objectSchemaOf<IConfigureAction>({
  type: Joi.string().required().valid(CONFIGURE),
  payload: configurePayloadSchema.required(),
});

export interface IConfigureAction {
  type: typeof CONFIGURE;
  payload: IConfigurePayload;
}

export const configure = actionCreator({
  type: CONFIGURE,
  schema: configureActionSchema,
});
